import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { allGroups } from "../../../../../api/account";
import InsLoader from "../../../../../components/InsLoader/InsLoader";
import { Link } from "react-router-dom";
import "./ProfileGroups.scss";

function ProfileGroups(props) {
  const [groups, setGroups] = useState([]);
  const [load, setLoad] = useState(true);

  const getGroups = () => {
    allGroups().then((data) => {
      setGroups(data);
      setLoad(false);
    });
  };

  useEffect(() => {
    getGroups();
  }, []);

  const { t } = props;
  return (
    <div className="groups">
      <div className="groups_header">
        <div>{t("my_groups")}</div>
      </div>
      <div className="groups_container default-layout--min-height">
        {!load ? (
          groups.map((group, index) => (
            <Link
              to={{
                pathname: "/profile/groups/" + group.id + "/courses",
                state: { transitionName: "slide_out", groupName: group.name },
              }}
              className="group"
              key={index}
            >
              <div
                className="square"
                style={{
                  backgroundImage: "url(" + group.picture + ")",
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              >
                <div className="overlay"></div>
                <div className="content">{group.name}</div>
              </div>
            </Link>
          ))
        ) : (
          <InsLoader />
        )}
      </div>
    </div>
  );
}

export default withTranslation()(ProfileGroups);
